<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
    <fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="'over'" [name]="'mainNavigation'"
        [navigation]="navigation?.default" [opened]="false">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <!-- <div class="flex items-center h-20 pt-6 px-8">
                <img
                    class=" w-24"
                    src="assets/images/logo/logo-text-on-dark.svg"
                    alt="Logo image">
            </div> -->
        </ng-container>
    </fuse-vertical-navigation>
    <fuse-vertical-navigation class="bg-primary-300 print:hidden" [mode]="'over'" [name]="'B2CNavigation'"
        [navigation]="navigation?.horizontal" [opened]="false">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            @if(view.site) {
            <div class="flex items-center h-20 pt-6 px-8">
                <img class="w-48" [src]="view.site?.logoUrl" alt="Logo image">
            </div>
            }
        </ng-container>
    </fuse-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 sm:h-20 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-primary-100 dark:bg-primary-700 dark:bg-transparent print:hidden client-version">
        <ng-container *ngIf="!isScreenSmall">
            <!-- Logo -->
            <div class="flex items-center mx-2 lg:mr-8">
                <!-- <div class="hidden lg:flex">
                    <img
                        class="dark:hidden w-24"
                        src="assets/images/logo/logo-text.svg">
                    <img
                        class="hidden dark:flex w-24"
                        src="assets/images/logo/logo1.png">
                </div> -->
                @if(view.site && (view.site.profileID == 10 || view.site.profileID == 13)) {
                <div class="flex items-center h-16 px-2">
                    <img class="w-22" [src]="view.site?.logoUrl" alt="Logo image">
                </div>
                }
                @if(view.site && view.site.id === 58) {
                <div class="flex items-center h-16 px-2">
                    <img class="w-56" [src]="view.site?.logoUrl" alt="Logo image">
                </div>
                }
                @if(view.site && (view.site.profileID != 10 && view.site.profileID != 13) && view.site.id !== 58) {
                <div class="flex items-center h-16 px-2">
                    <a href="{{view.site.website}}">
                        <img class="w-56" [src]="view.site?.logoUrl2" alt="Logo image">
                    </a>
                </div>
                }
            </div>
            <!-- Horizontal navigation -->
            <fuse-horizontal-navigation class="mr-2" [name]="'mainNavigation'"
                [navigation]="navigation?.horizontal"></fuse-horizontal-navigation>
        </ng-container>
        <!-- Navigation toggle button -->
        <ng-container *ngIf="isScreenSmall">
            @if (!view.isClient) {
            <button class="mr-2" mat-icon-button (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
            <search></search>
            }
        </ng-container>
        @if (view.isClient) {
        <ng-container *ngIf="isScreenSmall">
            <button mat-icon-button (click)="toggleNavigationB2C('B2CNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
        </ng-container>
        }
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">

            <section>
                <div class="flex flex-col md:flex-row md:items-center md:justify-center text-center md:text-left">
                    <!-- Contact -->
                    @if(view.site && view.site.id === 79) {
                    <div
                        class="flex flex-col items-center justify-center mt-5 md:mt-0 mb-4 md:mb-0 mr-5">
                        <div class="flex items-center mb-2 md:mb-0">
                            <mat-icon class="icon-size-4 text-primary-500 mr-2"
                                [svgIcon]="'mat_solid:local_phone'"></mat-icon>
                            <p class="tracking-wide font-narrow text-md">{{view.site?.telephone}}</p>
                        </div>
                        <div (click)="sendEmail(view.site?.emailAddress)"
                            class="flex items-center cursor-pointer mt-2 xl:mt-0 md:ml-6">
                            <mat-icon class="icon-size-4 text-primary-500 mr-2"
                                [svgIcon]="'mat_solid:email'"></mat-icon>
                            <p class="tracking-wide font-narrow text-md">{{view.site?.emailAddress}}</p>
                        </div>
                    </div>
                    }

                    <!-- Socials -->
                    <div class="hidden md:flex justify-center md:justify-start">
                        @if(view.site?.socialUrlFacebook) {
                        <a href="{{view.site?.socialUrlFacebook}}" target="_blank"
                            class="group w-6 h-6 mr-5 flex justify-center items-center transition-all duration-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-6 text-primary group-hover:text-accent"
                                [svgIcon]="'feather:facebook'"></mat-icon>
                        </a>
                        }
                        @if(view.site?.socialUrlInstagram) {
                        <a href="{{view.site?.socialUrlInstagram}}" target="_blank"
                            class="group w-6 h-6 mr-5 flex justify-center items-center transition-all duration-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-6 text-primary group-hover:text-accent"
                                [svgIcon]="'feather:instagram'"></mat-icon>
                        </a>
                        }
                        @if(view.site?.socialUrlLinkedIn) {
                        <a href="{{view.site?.socialUrlLinkedIn}}" target="_blank"
                            class="group w-6 h-6 mr-5 flex justify-center items-center transition-all duration-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-6 text-primary group-hover:text-accent"
                                [svgIcon]="'feather:linkedin'"></mat-icon>
                        </a>
                        }
                        @if(view.site?.socialUrlTwitter) {
                        <a href="{{view.site?.socialUrlTwitter}}" target="_blank"
                            class="group w-6 h-6 mr-5 flex justify-center items-center transition-all duration-500 hover:bg-primary-100">
                            <mat-icon class="icon-size-6 text-primary group-hover:text-accent"
                                [svgIcon]="'feather:twitter'"></mat-icon>
                        </a>
                        }
                    </div>
                </div>
            </section>

            <!-- <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <shortcuts></shortcuts>
            <messages></messages>
            <button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()">
                <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
            </button>
            <user></user> -->
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto w-full">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- @if (view.isClient && view.data.cart && view.data.cart.length > 0) {
    <mat-drawer
        class="m-auto dark:bg-gray-900 transition-all duration-500 fixed bottom-0 shadow-2xl w-11/12 bg-white pb-5 z-99 rounded-t-lg border-2 border-b-0 border-primary opacity-[97]"
        [position]="'end'" [autoFocus]="false"
        [mode]="view.drawerOptions && view.drawerOptions.mode == 'review' ? 'side' : drawerMode" [disableClose]="false"
        [opened]="view.data.cart && view.data.cart.length > 0" #drawerRight>
        <cart [options]="{loadCache:false, isClient:view.isClient}" (viewChange)="viewChanged($event)"
            (quoteCreated)="quoteCreated($event)"></cart>
    </mat-drawer>
    } -->

    <!-- Dynamic cart section -->
    <!-- @if (view.isClient && view.data.cart && view.data.cart.length > 0) {
        <mat-drawer class="m-auto h-50 dark:bg-gray-900 transition-all duration-500 fixed bottom-0 shadow-2xl w-full bg-white pb-3 rounded-t-lg border-2 border-b-0 border-primary opacity-0" [class.z-99]="view.data.cart && view.data.cart.length > 0" [class.opacity-95]="view.data.cart && view.data.cart.length > 0 || view.itinGuid" [position]="'end'" [autoFocus]="false" [mode]="view.drawerOptions && view.drawerOptions.mode == 'review' ? 'side' : drawerMode" [disableClose]="false" [opened]="view.data.cart && view.data.cart.length > 0" #drawerRight>
            <cart [options]="{loadCache:false, isClient:view.isClient}" (viewChange)="viewChanged($event)" (quoteCreated)="quoteCreated($event)"></cart>
        </mat-drawer>
        } -->

    <!-- Dynamic cart section -->
    @if (view.isClient && view.data.cart && view.data.cart.length > 0) {
    <mat-drawer
        class="m-auto dark:bg-gray-900 transition-all duration-500 fixed bottom-0 shadow-2xl w-11/12 bg-white pb-3 rounded-t-lg border-2 border-b-0 border-primary opacity-0"
        [class.z-99]="view.data.cart && view.data.cart.length > 0"
        [class.opacity-[97]]="view.data.cart && view.data.cart.length > 0 || view.itinGuid" [position]="'end'"
        [autoFocus]="false" [mode]="view.drawerOptions && view.drawerOptions.mode == 'review' ? 'side' : drawerMode"
        [disableClose]="false" [opened]="view.data.cart && view.data.cart.length > 0" #drawerRight>
        <cart [options]="{loadCache:false, isClient:view.isClient, compactColumns: true}" (viewChange)="viewChanged($event)"
            (quoteCreated)="quoteCreated($event)"></cart>
    </mat-drawer>
    }

    @if (view.isClient) {
    @if (view.site && view.site.profile && view.site.profile.sections) {
    @switch (view.site.profile.sections.footer ) {
    @case (1) {
    <app-footer-type01 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type01>
    }
    @case (2) {
    <app-footer-type02 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type02>
    }
    @case (3) {
    <app-footer-type03 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type03>
    }
    @case (4) {
    <app-footer-type04 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type04>
    }
    @case (5) {
    <app-footer-type05 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type05>
    }
    @case (6) {
    <app-footer-type06 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type06>
    }
    @case (7) {
    <app-footer-type07 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type07>
    }
    }
    }
    }

</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->